import { ButtonDS, useDevice } from "get-life-storybook-ts";
import React from "react";

interface QuoteBannerProps {
  title: string;
  subtitle?: string;
  offerTag?: string;
  offerTagColor?: "pink" | "orange";
  homeImage?: string;
  content?: any;
  subContent?: any;
  btnLabel?: string;
  btnOnClick?: any;
  trustpilot?: string;
  containerStyle?: string;
  subtitleTextStyle?: string;
  callmeLabel?: string;
  callmeLabelOnClick?: any;
  loadingQuote?: boolean;
  actionLabel?: string;
  showTruspilot?: boolean
  textUpperButton?: string;
}

const QuoteBanner: React.FC<QuoteBannerProps> = ({
  title,
  subtitle,
  offerTag,
  offerTagColor,
  homeImage,
  content,
  subContent,
  btnLabel,
  callmeLabel,
  callmeLabelOnClick,
  btnOnClick,
  trustpilot,
  containerStyle,
  subtitleTextStyle,
  actionLabel,
  showTruspilot,
  textUpperButton
}) => {
  const { isMobile } = useDevice();

  return (
    <div
      className={`md:h-fit relative px-5 min-h-[300px] ${containerStyle}`}
    >
      <h1
        className={`font-bold md:text-5xl text-3xl text-white text-left md:text-center pt-[70px] md:pt-7 ${containerStyle} ${content ? "md:mb-[32px] mb-[8px]" : ""
          }`}
      >
        {title && <>{title},</>}
        {subtitle && (
          <>
            {title ? <><br />{" "}</> : null}
            <span className={`font-normal font-MW ${subtitleTextStyle}`}>
              {subtitle}
            </span>
          </>
        )}
      </h1>
      <div>
        <div className="text-left md:text-center">{content}</div>
        <div className="text-left md:text-center pt-1">
          {subContent}
        </div>
      </div>

      <div
        className={`flex flex-col ${isMobile ? `items-start` : `items-center`
          } gap-5 pb-14`}
      >
        {showTruspilot && (
          <>
            <div className="flex flex-col text-[#7B7B7B] md:items-center justify-center md:mt-[28px] mt-[18px] BodyS">
              <TrustPilotSVG />
              {trustpilot ? <span dangerouslySetInnerHTML={{ __html: trustpilot }} /> : null}
            </div>
          </>
        )}

        {textUpperButton && (
          <>
            <div className="flex flex-col text-[#7B7B7B] md:items-center justify-center md:mt-[28px] mt-[18px] BodyS">
              {<span className="text-[#7B7B7B] font-medium BodyL" dangerouslySetInnerHTML={{ __html: textUpperButton }} />}
            </div>
          </>
        )}

        {btnLabel && (
          <div className="flex md:flex items-center justify-center md:mt-[44px] mt-[34px]">
            <div className={`flex flex-col`}>
              <ButtonDS
                label={btnLabel}
                onClick={btnOnClick}
                className="!w-full"
                rightIcon={callmeLabel ? undefined : "ArrowRightIcon"}
              />
              {callmeLabel && (
                <ButtonDS
                  label={callmeLabel}
                  onClick={callmeLabelOnClick}
                  buttonType="secondary"
                  className="!w-full mt-[16px]"
                />
              )}
              {actionLabel ? <span className="mt-[8px] BodyS font-bold text-[#7B7B7B]" dangerouslySetInnerHTML={{ __html: actionLabel }} /> : null}
            </div>
          </div>
        )}

        {homeImage && <img src={homeImage} alt="home"></img>}

        {offerTag && (
          <OfferSticker offerTag={offerTag} offerTagColor={offerTagColor} />
        )}
      </div>
    </div>
  );
};

const OfferSticker = ({ offerTag, offerTagColor }: any) => {
  let bg =
    offerTagColor === "pink"
      ? "bg-pink"
      : offerTagColor === "orange"
        ? "bg-orange"
        : "";
  let text =
    offerTagColor === "pink"
      ? "text-purple"
      : offerTagColor === "orange"
        ? "text-white"
        : "";

  return (
    <div
      className={`absolute  
      w-[120px] h-[120px] md:w-[160px] left-[60%] -bottom-[15%] md:h-[160px] md:left-[70%] md:-bottom-[10%] p-6 
      rounded-full rotate-6 ${bg}
    `}
    >
      <p
        className={`absolute inset-center font-black text-[18px] md:text-[25px] text-center tracking-[-0.04em] ${text}`}
      >
        {offerTag}
      </p>
    </div>
  );
};

export const TrustPilotSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={148}
    height={20}
    fill="none"
  >
    <path
      fill="#424242"
      d="M18.93 6.494h7v1.324h-2.752v7.443h-1.513V7.818h-2.74V6.494h.006Zm6.701 2.42h1.294v1.224h.024c.043-.173.122-.34.238-.501.116-.16.256-.316.421-.446.165-.136.348-.24.55-.327a1.66 1.66 0 0 1 .616-.124c.158 0 .274.006.335.012s.122.019.19.025v1.349a4.28 4.28 0 0 0-.3-.044 2.495 2.495 0 0 0-.299-.018 1.52 1.52 0 0 0-1.196.557 2.112 2.112 0 0 0-.366.68 2.919 2.919 0 0 0-.134.934v3.02h-1.38V8.912h.007Zm10.008 6.347h-1.355v-.885h-.025c-.17.322-.42.575-.756.767-.336.192-.678.29-1.025.29-.824 0-1.422-.203-1.788-.618-.366-.414-.55-1.04-.55-1.874V8.913h1.38v3.892c0 .556.103.952.317 1.181.207.229.506.347.885.347.293 0 .53-.044.726-.137.195-.092.354-.21.47-.365.122-.148.207-.334.262-.544.055-.21.08-.44.08-.687V8.92h1.379v6.34Zm2.349-2.036c.043.409.195.693.458.86.268.16.585.248.958.248.128 0 .274-.013.439-.031a1.82 1.82 0 0 0 .464-.118.892.892 0 0 0 .36-.254.62.62 0 0 0 .128-.433.601.601 0 0 0-.196-.439 1.373 1.373 0 0 0-.463-.278 4.618 4.618 0 0 0-.647-.18c-.244-.05-.488-.105-.738-.16a6.945 6.945 0 0 1-.745-.21 2.262 2.262 0 0 1-.64-.335 1.464 1.464 0 0 1-.452-.532c-.116-.216-.171-.483-.171-.804 0-.347.085-.631.25-.866.165-.235.378-.421.629-.563.256-.143.537-.242.848-.304.311-.055.61-.086.89-.086.324 0 .635.037.928.105.293.068.562.18.8.34.238.155.433.36.592.607.158.247.256.55.299.903h-1.44c-.068-.334-.214-.563-.452-.675a1.828 1.828 0 0 0-.818-.173c-.097 0-.213.006-.347.025-.135.019-.257.05-.379.093a.82.82 0 0 0-.299.198.482.482 0 0 0-.122.34c0 .173.061.31.177.415.116.105.269.191.458.266.189.068.402.13.647.179.244.05.494.105.75.16.25.056.494.13.738.211.244.08.458.192.647.334.19.143.342.316.458.526.116.21.177.476.177.786 0 .377-.085.693-.256.959-.171.26-.39.476-.66.637-.268.16-.573.284-.903.359a4.476 4.476 0 0 1-2.08-.025 2.658 2.658 0 0 1-.873-.408 2.018 2.018 0 0 1-.58-.687c-.14-.272-.213-.6-.226-.977h1.392v-.013Zm4.552-4.312h1.044V7.008h1.379v1.905h1.244V9.96h-1.244v3.39c0 .148.006.272.018.383a.713.713 0 0 0 .085.273c.043.074.11.13.202.167a.971.971 0 0 0 .366.055c.097 0 .195 0 .293-.006a1.6 1.6 0 0 0 .293-.043v1.082c-.153.02-.306.031-.446.05a3.511 3.511 0 0 1-.445.025c-.366 0-.66-.037-.879-.105a1.137 1.137 0 0 1-.519-.31 1.08 1.08 0 0 1-.256-.507 3.867 3.867 0 0 1-.08-.7V9.972h-1.043V8.913h-.012Zm4.644 0h1.306v.86h.024c.195-.371.464-.631.812-.792.347-.16.72-.241 1.129-.241.494 0 .92.086 1.287.266.366.173.671.414.915.724s.421.668.543 1.076c.122.409.183.848.183 1.312 0 .427-.054.841-.164 1.237-.11.402-.275.755-.495 1.064-.22.31-.5.55-.842.736-.341.186-.738.279-1.202.279-.201 0-.402-.019-.604-.056a2.635 2.635 0 0 1-.58-.18 2.087 2.087 0 0 1-.909-.76h-.024v3.167h-1.38V8.913Zm4.82 3.18c0-.285-.036-.563-.11-.835a2.269 2.269 0 0 0-.329-.718 1.688 1.688 0 0 0-.543-.5 1.506 1.506 0 0 0-.75-.193c-.58 0-1.02.204-1.313.613-.293.408-.439.952-.439 1.633 0 .322.037.619.116.89a2 2 0 0 0 .348.706c.152.198.335.353.549.464.214.118.464.173.745.173.317 0 .58-.068.799-.198.22-.13.397-.303.537-.507.14-.21.244-.445.305-.711a4.03 4.03 0 0 0 .085-.817Zm2.435-5.599h1.38v1.324h-1.38V6.494Zm0 2.42h1.38v6.347h-1.38V8.913Zm2.612-2.42h1.379v8.767h-1.38V6.494Zm5.608 8.94c-.5 0-.946-.087-1.337-.254a2.949 2.949 0 0 1-.994-.693 3.025 3.025 0 0 1-.617-1.058 4.133 4.133 0 0 1-.213-1.348c0-.483.073-.928.213-1.337.14-.408.348-.76.617-1.058a2.81 2.81 0 0 1 .994-.692 3.37 3.37 0 0 1 1.337-.254c.5 0 .946.086 1.336.254.39.167.72.402.995.692.268.297.476.65.616 1.058.14.409.214.854.214 1.337 0 .488-.074.94-.214 1.348-.14.409-.348.761-.616 1.058a2.809 2.809 0 0 1-.995.693 3.37 3.37 0 0 1-1.336.254Zm0-1.108c.305 0 .573-.068.8-.198a1.71 1.71 0 0 0 .554-.513c.147-.21.25-.452.324-.718a3.33 3.33 0 0 0 .103-.816c0-.273-.036-.539-.103-.81a2.132 2.132 0 0 0-.324-.719 1.693 1.693 0 0 0-.555-.507 1.582 1.582 0 0 0-.8-.198c-.304 0-.573.068-.799.198-.225.13-.409.303-.555.508a2.26 2.26 0 0 0-.323.717 3.355 3.355 0 0 0-.104.81c0 .279.036.551.104.817.067.266.177.508.323.718.146.21.33.383.555.513.226.136.495.198.8.198Zm3.563-5.413h1.044V7.008h1.379v1.905h1.245V9.96h-1.245v3.39c0 .148.006.272.018.383a.713.713 0 0 0 .086.273c.042.074.11.13.201.167a.972.972 0 0 0 .366.055c.098 0 .195 0 .293-.006.098-.006.195-.018.293-.043v1.082c-.153.02-.305.031-.445.05a3.513 3.513 0 0 1-.446.025c-.366 0-.659-.037-.879-.105a1.137 1.137 0 0 1-.518-.31 1.08 1.08 0 0 1-.257-.507 3.867 3.867 0 0 1-.079-.7V9.972h-1.043V8.913h-.013Z"
    />
    <path
      fill="#00B878"
      d="M17.32 6.495h-6.322L9.046.395l-1.96 6.1-6.32-.007 5.119 3.774-1.959 6.094 5.12-3.768 5.113 3.768-1.952-6.094 5.113-3.767Z"
    />
    <path fill="#424242" d="m12.646 11.641-.44-1.38-3.16 2.327 3.6-.947Z" />
    <g clipPath="url(#a)">
      <path
        fill="#00B67A"
        d="M90.902 3.5h-13v13h13v-13ZM104.985 3.5h-13v13h13v-13ZM119.069 3.5h-13v13h13v-13ZM133.152 3.5h-13v13h13v-13Z"
      />
      <path fill="#DCDCE6" d="M147.235 3.5h-6.5v13h6.5v-13Z" />
      <path fill="#00B67A" d="M140.735 3.5h-6.5v13h6.5v-13Z" />
      <path
        fill="#fff"
        d="m84.402 12.262 1.977-.502.826 2.546-2.803-2.044Zm4.55-3.291h-3.48l-1.07-3.277-1.07 3.277h-3.48l2.817 2.031-1.07 3.277 2.817-2.031 1.733-1.246 2.803-2.031ZM98.485 12.262l1.977-.502.826 2.546-2.803-2.044Zm4.55-3.291h-3.48l-1.07-3.277-1.07 3.277h-3.48l2.817 2.031-1.07 3.277 2.817-2.031 1.733-1.246 2.803-2.031ZM112.568 12.262l1.977-.502.826 2.546-2.803-2.044Zm4.55-3.291h-3.48l-1.07-3.277-1.07 3.277h-3.48l2.817 2.031-1.07 3.277 2.817-2.031 1.733-1.246 2.803-2.031ZM126.652 12.262l1.977-.502.826 2.546-2.803-2.044Zm4.55-3.291h-3.48l-1.07-3.277-1.07 3.277h-3.48l2.817 2.031-1.07 3.277 2.817-2.031 1.733-1.246 2.803-2.031ZM140.735 12.262l1.977-.502.826 2.546-2.803-2.044Zm4.55-3.291h-3.48l-1.07-3.277-1.07 3.277h-3.48l2.817 2.031-1.07 3.277 2.817-2.031 1.733-1.246 2.803-2.031Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M77.902 3.5h69.333v13H77.902z" />
      </clipPath>
    </defs>
  </svg>
)

export default QuoteBanner;
